var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-row",
    { staticClass: "my-3" },
    [
      _vm.process
        ? _c(
            "vs-col",
            {
              staticClass: "text-primary d-flex justify-content-between",
              attrs: { "vs-lg": "12" }
            },
            [
              _c(
                "div",
                { staticClass: "my-3" },
                [
                  _c("b-form-checkbox", {
                    staticClass: "d-inline-block",
                    attrs: { "data-cy": "select-all" },
                    on: {
                      change: function($event) {
                        return _vm.$emit("select-all", _vm.selectAll)
                      }
                    },
                    model: {
                      value: _vm.selectAll,
                      callback: function($$v) {
                        _vm.selectAll = $$v
                      },
                      expression: "selectAll"
                    }
                  }),
                  _vm._v(" Seleccionar todos ")
                ],
                1
              ),
              _vm.process && _vm.selectedFlows.length
                ? _c(
                    "b-button",
                    {
                      staticClass: "float-right",
                      attrs: {
                        "data-cy": "process-massive-button",
                        variant: "info",
                        size: "sm"
                      },
                      on: {
                        click: function($event) {
                          return _vm.$emit("attempt-process")
                        }
                      }
                    },
                    [
                      _c("feather-icon", {
                        staticClass: "mr-50",
                        attrs: { icon: "PlayIcon" }
                      }),
                      _c("span", { staticClass: "align-middle" }, [
                        _vm._v("Procesar")
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _c(
        "vs-col",
        { attrs: { "vs-lg": "12" } },
        [
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.process || _vm.process === "approve",
                  expression: "!process || process === 'approve'"
                }
              ],
              staticClass: "mr-2",
              attrs: {
                "data-cy": "approve-massive-button",
                variant: "success",
                size: "sm"
              },
              on: {
                click: function($event) {
                  return _vm.$emit("massive-process", "approve")
                }
              }
            },
            [
              _c("feather-icon", {
                staticClass: "mr-50",
                attrs: { icon: "CheckIcon" }
              }),
              _c("span", { staticClass: "align-middle" }, [_vm._v("Aprobar")])
            ],
            1
          ),
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.process || _vm.process === "sign",
                  expression: "!process || process === 'sign'"
                }
              ],
              staticClass: "mr-2",
              attrs: {
                "data-cy": "sign-massive-button",
                variant: "info",
                size: "sm"
              },
              on: {
                click: function($event) {
                  return _vm.$emit("massive-process", "sign")
                }
              }
            },
            [
              _c("feather-icon", {
                staticClass: "mr-50",
                attrs: { icon: "EditIcon" }
              }),
              _c("span", { staticClass: "align-middle" }, [_vm._v("Firmar")])
            ],
            1
          ),
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.process || _vm.process === "reject",
                  expression: "!process || process === 'reject'"
                }
              ],
              staticClass: "mr-2",
              attrs: {
                "data-cy": "reject-massive-button",
                variant: "danger",
                size: "sm"
              },
              on: {
                click: function($event) {
                  return _vm.$emit("massive-process", "reject")
                }
              }
            },
            [
              _c("feather-icon", {
                staticClass: "mr-50",
                attrs: { icon: "XCircleIcon" }
              }),
              _c("span", { staticClass: "align-middle" }, [_vm._v("Rechazar")])
            ],
            1
          ),
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.process || _vm.process === "assign",
                  expression: "!process || process === 'assign'"
                }
              ],
              staticClass: "mr-2",
              attrs: {
                "data-cy": "assign-massive-button",
                variant: "primary",
                size: "sm"
              },
              on: {
                click: function($event) {
                  return _vm.$emit("massive-process", "assign")
                }
              }
            },
            [
              _c("feather-icon", {
                staticClass: "mr-50",
                attrs: { icon: "UserCheckIcon" }
              }),
              _c("span", { staticClass: "align-middle" }, [_vm._v("Asignar")])
            ],
            1
          ),
          _vm.process
            ? _c(
                "b-button",
                {
                  attrs: {
                    "data-cy": "cancel-massive-button",
                    variant: "secondary",
                    size: "sm"
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("cancel")
                    }
                  }
                },
                [
                  _c("feather-icon", {
                    staticClass: "mr-50",
                    attrs: { icon: "XIcon" }
                  }),
                  _c("span", { staticClass: "align-middle" }, [
                    _vm._v("Cancelar")
                  ])
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }